<template>
  <div class="gheom-overlay" >
  </div>
</template>

<script>
export default {
  name: "",
  props: [
    ""
  ],
  data:function(){ 
    return {

    }
  },
  computed: {

  },
  methods: {
 
  }
}
</script>

